import React, { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import purchaceprofile from "../../assets/images/purchaceprofile.svg";
import Email from "../../assets/images/email.svg";
import call from "../../assets/images/call.svg";
import boxcount from "../../assets/images/boxcount.svg";
import downloadAction from "../../assets/images/download.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  GetMachineDashboardList,
  MachinePurchaseList,
} from "../../services/ReduxTookit/Slice/MachineRedux";
import annualsummary from "../../assets/images/My_machine.svg";
import DemoLogo from "../../assets/images/quantummain.svg";
import { commonservices } from "../../services/CommonServices";
import Nodata from "../../component/common-component/Nodata";
import { useNavigate } from "react-router-dom";
import Loader, { LoaderType } from "../../component/common-component/Loader";
import Skeleton from "react-loading-skeleton";
import stars from "../../assets/images/stars.svg";

const MachinesManagementModel = () => {
  let dispatch = useDispatch();
  let navigate = useNavigate();
  const [machineLoading, setMachineLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [machineList, setMachineList] = useState([]);
  
  const firstTimeApiCalledRef = useRef(false);
  const [totalRecord, setTotalRecord] = useState(1);
  const [newStateManage, setNewStateManage] = useState({
    page: 1,
    catagory: "",
    status: "",
    search: "",
  });

  const getMachineList = async () => {
    if (loading) return;
    if (newStateManage?.page === 1) {
      setMachineLoading(true);
    } else {
      setLoading(true);
    }
    const getDiv = document.querySelector("#profileMachineListing");
    if (getDiv) {
      getDiv.removeEventListener("scroll", handleScroll);
    }
    let body = {
      machinename: "",
      status: newStateManage?.status,
      pagenumber: newStateManage?.page,
      pagesize: 9,
      categoryids: "",
    };
    dispatch(GetMachineDashboardList(body))
      ?.then((response) => {
        if (response?.payload?.isValidate) {
          firstTimeApiCalledRef.current = true;

          if (newStateManage?.page === 1) {
            setMachineList(response?.payload?.data?.data?.dataList1);
          } else {
            setMachineList((prev) => [
              ...prev,
              ...response?.payload?.data?.data?.dataList1,
            ]);
          }
          if (response?.payload?.data?.data?.dataList1?.length > 0) {
            setTotalRecord(response?.payload?.data?.recordcount);
          } else {
            setTotalRecord(1);
          }
          setMachineLoading(false);
          if (
            getDiv &&
            machineList?.length +
              response?.payload?.data?.data?.dataList1.length <=
              response?.payload?.data?.recordcount
          ) {
            getDiv.addEventListener("scroll", handleScroll);
          } else {
            getDiv.removeEventListener("scroll", handleScroll);
          }
          setMachineLoading(false);
        }

        if (!response?.payload?.isValidate) {
          setMachineList([]);
          setMachineLoading(false);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (machineList?.length < totalRecord) {
      getMachineList();
    }
  }, [newStateManage]);

  const handleScroll = () => {
    const getDivData = document.querySelector("#profileMachineListing");
    let scrollHeight = getDivData.scrollHeight;
    let scrollTop = getDivData.scrollTop;
    let clientHeight = getDivData.clientHeight;
    if (
      scrollHeight < scrollTop + clientHeight + 100 &&
      !loading &&
      machineList?.length <= machineList?.length <= totalRecord
    ) {
      document
        .querySelector("#profileMachineListing")
        .removeEventListener("scroll", handleScroll);
      let a = { ...newStateManage };
      a.page += 1;
      setNewStateManage(a);
    }
  };

  return (
    <>
      <div className="profile-machine-main" id="profileMachineListing">
        {machineLoading ? (
          <Loader type={LoaderType.SupportSetting} count={8} />
        ) : (
          <>
            {machineList?.length > 0 ? (
              <>
                {machineList?.map((item, index) => {
                  let versionCount = item?.versioncount
                    ? parseInt(item?.versioncount)
                    : "";
                  if (versionCount) {
                    versionCount = versionCount - 1;
                  }
                  return (
                    <div
                      className="profile-common profile-code-machine-data"
                      key={index}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <Col xl={4}>
                          <div className="profile-purchases-inner d-flex gap-3 align-items-center">
                            <div className="profile-purchases-pic">
                              <img
                                src={
                                  item?.machinelogo !== "" &&
                                  item?.machinelogo !== null
                                    ? item?.machinelogo
                                    : DemoLogo
                                }
                                width={"25px"}
                                height={"25px"}
                                alt={item?.machinename}
                                onError={({ currentTarget }) => {
                                  currentTarget.onerror = null;
                                  currentTarget.src = DemoLogo;
                                }}
                              />
                            </div>
                            <div>
                              <div className="purchase-listing-show d-flex">
                                <p
                                  className="fw600 cursor-pointer"
                                  title={item?.machinename}
                                  onClick={() =>
                                    navigate(
                                      `/marketplace/marketplace-detail/${commonservices.bodyEncryption(
                                        String(item?.machineid)
                                      )}/Marketplace`
                                    )
                                  }
                                >
                                  {item?.machinename}
                                </p>
                                <div className="market-place-content-ratings ms-2">
                                  <img src={stars} alt="stars" />
                                  <span>
                                    {item?.averagerating?.toFixed(1) || 0}
                                  </span>
                                </div>
                              </div>

                              <div
                                className="grey-btn purchase-content"
                                style={{ padding: "5px 5px" }}
                              >
                                {item?.categoryname}
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col xl={4}>
                          <div className="machine-detail-industry">
                            <div className="d-flex align-items-center gap-2 mt-1 ">
                              <span>Industry :</span>
                              <span className="theme-color-text fw600">
                                {item?.industryname}
                              </span>
                            </div>
                            <div className="d-flex align-items-center gap-1 justify-content-center">
                              {item?.versionnumber}
                              {versionCount > 0 ? (
                                <span className="blueround-bage">
                                  {" "}
                                  +{versionCount}
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </Col>
                        <Col xl={2}>
                          <div className="countdata">
                            <div className=" d-flex align-items-center gap-1">
                              <img src={boxcount} alt="boxcount" />
                              <h3>
                                {item?.workflowcount ? item?.workflowcount : 0}
                              </h3>
                            </div>
                          </div>
                        </Col>
                        <Col xl={2}>
                          <div className="dateprice">
                            <h3>
                              {item?.revenue
                                ? commonservices.formateAmount(item?.revenue)
                                : commonservices.formateAmount(0)}
                            </h3>
                            <p>
                              {item?.createdon
                                ? commonservices.convertDateAndTimeInLocalTimeZone(
                                    item?.createdon,
                                    "MMMM DD, YYYY"
                                  )
                                : ""}
                            </p>
                          </div>
                        </Col>
                      </div>
                    </div>
                  );
                })}
                {loading && (
                  <Loader type={LoaderType.SupportSetting} count={5} />
                )}
              </>
            ) : (
              <>
                <Nodata />
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default MachinesManagementModel;
